import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export function sanitizeFilename(filename: string) {
  // Remove unsafe characters
  const unsafeCharacters = /[<>:"/\\|?*\x00-\x1F]/g;
  let safeFilename = filename.replace(unsafeCharacters, '');

  // Replace multiple spaces with a single space
  safeFilename = safeFilename.replace(/\s+/g, ' ').trim();

  // Ensure the filename is not empty
  if (safeFilename.length === 0) {
    safeFilename = 'file';
  }

  return safeFilename;
}

export function download(blob: Blob, filename: string) {
  const a = window.document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function downloadImage(imageUrl: string, filename: string) {
  saveAs(imageUrl, filename);
}

export function downloadAsPdf(pdfString: string, filename: string) {
  const a = window.document.createElement('a');
  a.href = `data:application/octet-stream;base64,${pdfString}`;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function downloadAsExcelFile(buffer: any, fileName: string) {
  let EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  let EXCEL_EXTENSION = '.xlsx';
  const data = new Blob([buffer], {
    type: EXCEL_TYPE,
  });
  saveAs(
    data,
    fileName +
      '_export_' +
      new Date(Date.now()).toISOString().substring(0, 19) +
      EXCEL_EXTENSION,
  );
}

export async function downloadJsonDataAsExcelFile(
  jsonData: any[],
  fileName: string,
) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('data');

  if (jsonData.length > 0) {
    worksheet.columns = Object.keys(jsonData[0]).map((key) => ({
      header: key,
      key,
    }));
    worksheet.addRows(jsonData);
  }

  const buffer = await workbook.xlsx.writeBuffer();
  downloadAsExcelFile(buffer, fileName);
}
